import { render, staticRenderFns } from "./MetadataView.vue?vue&type=template&id=665b4ce8&scoped=true"
import script from "./MetadataView.vue?vue&type=script&lang=ts"
export * from "./MetadataView.vue?vue&type=script&lang=ts"
import style0 from "./MetadataView.vue?vue&type=style&index=0&id=665b4ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b4ce8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/build/apps/legacy/components/zeal/ZIcon/ZIcon.vue').default,AnalyzerLogo: require('/build/apps/legacy/components/AnalyzerLogo.vue').default,AnalyzerList: require('/build/apps/legacy/components/Repository/AnalyzerList.vue').default,LastRunInfo: require('/build/apps/legacy/components/Repository/LastRunInfo.vue').default})
